export const PRODUCT_CARD_CSS = /* css */ `
  .lk-product-card-rating {
    display: flex; align-items: center; gap: 6px;
    margin: 2px 0 6px;
  }
  .lk-product-card-stars { display: inline-flex; align-items: center; gap: 1px; }
  .lk-product-card-stars .lk-star { display: block; color: var(--wg-border, #e0e0e0); }
  .lk-product-card-stars .lk-star--on { color: var(--wg-accent, #FF6602); }
  .lk-product-card-rating-count {
    font-size: 11px; color: var(--wg-card-fg-muted, #586577); font-weight: 500;
  }
  .lk-product-cards {
    display: flex;
    gap: 16px;
    overflow-x: auto;
    padding: 8px 4px 24px;
    margin: 0 -4px;
    scrollbar-width: none;
  }
  .lk-product-cards::-webkit-scrollbar { display: none; }
  .lk-product-card {
    flex: 0 0 auto;
    width: 240px;
    border-radius: 14px;
    overflow: hidden;
    background: var(--wg-bg);
    box-shadow: var(--wg-card-shadow);
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: inherit;
    transition: transform 0.15s ease-out, box-shadow 0.15s ease-out;
    animation: lk-card-in 0.4s ease backwards;
  }
  .lk-product-cards .lk-product-card:nth-child(2) { animation-delay: 0.1s; }
  .lk-product-cards .lk-product-card:nth-child(3) { animation-delay: 0.2s; }
  .lk-product-card:hover {
    transform: scale(1.02);
    box-shadow: var(--wg-card-shadow-hover);
  }
  .lk-product-card-image {
    height: 160px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #f8f8f8;
    flex-shrink: 0;
  }
  .lk-product-card-body {
    padding: 12px 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: var(--wg-card-fg);
  }
  .lk-product-card-top {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .lk-product-card-brand {
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.3px;
    color: var(--wg-fg-muted);
    text-transform: uppercase;
  }
  .lk-product-card-name {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: -0.28px;
    color: var(--wg-card-fg);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .lk-product-card-desc {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: -0.12px;
    color: var(--wg-card-fg-muted);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .lk-product-card-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: auto;
  }
  .lk-product-card-price {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: -0.32px;
    color: var(--wg-card-fg);
  }
  .lk-product-card-cta {
    display: inline-block;
    padding: 6px 14px;
    background: var(--wg-cta-bg);
    color: var(--wg-fg);
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.12px;
    border-radius: 999px;
    text-decoration: none;
  }
  .lk-product-card:hover .lk-product-card-cta {
    background: var(--wg-cta-bg-hover);
  }
`;
